import React from 'react';

import './Programs.patient.scss';
import moment from 'moment';
import { PatientAvatar } from '../visuals/Patient.avatar';
import KitAssignPop from '../visuals/Kit.assignPop';
import {useNavigate} from 'react-router-dom';

import ItemMenu from '../forms/menu/MenuComponent';
import {getDateFormat} from "../utils/date";
import {useTranslation} from "react-i18next";
import Checkbox from "../forms/inputs/Checkboxk";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

function ProgramBasePatient({ currentOrg, currentUser, patient, selectedPatients, selected, onSelected, onAdd, onChange, requestAssignKit, hideMenu, onDownloadBioReports, patientsBioDevices }) {
    const {t} = useTranslation(['programs','common','teams'])
    const navigate = useNavigate();
    const handleClick = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_PARTICIPANTS, {tag: 'row', event: 'onClick', action: 'click row patient', patient_id: patient._id});
        onSelected(patient)
    }
    const goToViewPatient = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_PARTICIPANTS, {tag: 'button', event: 'onClick', action: 'click option patient detail', patient_id: patient._id});
        navigate(`/participants/view/${patient._id}`)
    }
    const getPatientStatus = () => {
        if(patient.isPaused){return 'paused'}
        else if(patient.isDisenrolled){return 'disenrolled'}
        else if(!patient.programId){return 'registered'}
        else if(patient.programId){return 'enrolled'}
    }
    const getPhone = (phone) => {
        if (!phone || !phone.number) {
            return '--';
        }
        if (phone.number.search(/\+/) !== -1) {
                return phone.number;
            }
        return '+' + phone.code + ' ' + phone.number;
    }
    const isChecked = () => {
        return selectedPatients.find((t) => t._id === patient._id);
    }
    const phone = patient.phones.find(ph => ph.label === 'Mobile') || patient.phones[0];
    const dobMoment = patient.dateOfBirth? moment(patient.dateOfBirth) : 0;

    const enableDownloadBioReports = () => {
        if (!patientsBioDevices.find((p) => p._id === patient._id)) {
            return false;
        }
        return currentUser.clinician.role === 'clinician' || currentUser.clinician.role === 'admin';
    }

    const _onDownloadBioReports = () => {
        if (onDownloadBioReports && enableDownloadBioReports()) {
            onDownloadBioReports();
        }
    }


    return (
        <div className={`__ProgramBasePatient ${selected ? 'selected' : ''}`} onClick={handleClick}>
            <div>
                {
                    currentUser.userRoles.userPatients.edit? <Checkbox bool={isChecked()} onChange={() => onChange(patient)}/> : ''
                }
            </div>
            <PatientAvatar bio={patient.user.bio} small={true} status={getPatientStatus()}/>
            <div className="name">
                <h3 onClick={goToViewPatient}>
                    {patient.user.bio.lastname}, {patient.user.bio.firstname}
                </h3>
                {
                    patient.isNew ?
                        <div className="_isNew">
                            {t('common:new')}
                    </div>
                        : ''
                }
            </div>
            <p className="centered">
                {dobMoment? moment().diff(dobMoment, 'years') : '--'}
            </p>
            <p>
                {patient.user.bio.gender}
            </p>
            <p>
                {getDateFormat(currentOrg, patient.dateOfBirth, 'short')}
            </p>
            <p>
                {
                    getPhone(phone)
                }
            </p>
            {
                currentUser.userRoles.programsRules.edit || patient.kitId?
                    <KitAssignPop kit={patient.kitId} pop={true} handleClick={requestAssignKit} /> : <p></p>
            }
            {
                !patient.lastDataSeen ?
                    <div className="noData">
                        <p>
                            {t('common:no-data')}
                    </p>
                    </div>
                    : <div></div>
            }
            <div>
                {
                    currentUser.userRoles.userPatients.edit?
                        <ItemMenu actionWillRedirect={false} fixed={true} label={'Participant Options'}
                                  event={PAGES.PROGRAM_PARTICIPANTS} eventParams={{patient_id: patient._id}}>
                            <>
                                {
                                    hideMenu? '':
                                        <div className="_option" onClick={requestAssignKit}>
                                            <p>{!!patient.kitId && !!patient.kitId.length ? t('add-additional-kit') : t('add-kit')}</p>
                                        </div>
                                }
                                <div className="_option" onClick={goToViewPatient}>
                                    <p>{t('participant-details')}</p>
                                </div>
                                <div className="_option" onClick={() => onAdd(patient)}>
                                    <p>{selectedPatients.length <= 1? t('teams:assign-unassign-single-participant'): t('teams:assign-unassign-multiple-participants')}</p>
                                </div>
                                {
                                    enableDownloadBioReports()?
                                        <div className={`_option`} onClick={_onDownloadBioReports}><p>Generate BioReport(s)</p></div> : ''
                                }
                            </>
                        </ItemMenu> : <div></div>
                }
            </div>

        </div>
    )
}

export default ProgramBasePatient;
